import { isCustomizationFeatureEnabled } from '../../handoff-metrics/handoff-metrics-helpers';
import {
  fullPaymentsWithTerminalMetric,
  paymentsStripeAccountMetric,
} from '../../handoff-metrics/metrics/payments';
import { UnifyMetricDefinition, UnifyMetricEvalContext } from '../unify-metrics.types';
import { adaptHandoffMetric } from './adapt-handoff-metric';

const shouldSkipPayments = (ctx: UnifyMetricEvalContext) =>
  !isCustomizationFeatureEnabled('Weave Pay', ctx.features);

export const stripeAccountMetricDef: UnifyMetricDefinition = {
  id: 'stripe_account_set_up',
  name: 'Stripe account set up',
  sectionName: 'Payments',
  allowExceptions: true,
  shouldSkip: shouldSkipPayments,
  criteria: [adaptHandoffMetric(paymentsStripeAccountMetric)],
};

export const paymentsWithTerminalMetricDef: UnifyMetricDefinition = {
  id: 'payments_with_terminal',
  name: 'Payments with terminal',
  sectionName: 'Payments',
  allowExceptions: true,
  shouldSkip: (ctx) =>
    shouldSkipPayments(ctx) ||
    !isCustomizationFeatureEnabled('Payment Terminals', ctx.features),
  criteria: [adaptHandoffMetric(fullPaymentsWithTerminalMetric)],
};
